import { render } from "./ResumePassInfo.vue?vue&type=template&id=521abe00&scoped=true"
import script from "./ResumePassInfo.vue?vue&type=script&lang=js"
export * from "./ResumePassInfo.vue?vue&type=script&lang=js"

import "./ResumePassInfo.vue?vue&type=style&index=0&id=521abe00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521abe00"]])

export default __exports__